export interface EventAction {
  id: number | string;
  displayConfirmButton?: boolean;
  status?: string;
  auditId?: number;
  actions?: EventActionItem[];
}

export interface EventActionItem {
  label: string;
  i18nKey?: string;
  icon: string;
  disabled?: boolean;
  disabledTooltipLabel?: string;
  command?: any;
}
